<template>
  <ValidationObserver ref="observer">
    <OnboardingModalContent
      :title="$t('onboarding_security_subtitle')"
      :error="formError"
    >
      <div class="tw-grid tw-grid-cols-1 tw-grid-rows-2 tw-mt-4">
        <div>
          <OnboardingField
            for-id="security-question-1"
            :label="$t('onboarding_security_question_1')"
            validation-rules="required"
          >
            <Select
              id="security-question-1"
              v-model="securityQuestions[0].question"
            >
              <option
                v-for="option in questionsLeftFirstQuestion"
                :key="option.question"
                :value="option.question"
              >
                {{ option.label }}
              </option>
            </Select>
          </OnboardingField>
          <ValidationProvider
            rules="required"
            :name="$t('settings__security_questions_answer') + ' #1'"
          >
            <OnboardingInput
              v-model="securityQuestions[0].response"
              data-testid="security_questions_answer-1"
            />
          </ValidationProvider>
        </div>
        <div>
          <OnboardingField
            for-id="security-question-2"
            :label="$t('onboarding_security_question_2')"
            validation-rules="required"
          >
            <Select
              id="security-question-2"
              v-model="securityQuestions[1].question"
            >
              <option
                v-for="option in questionsLeftSecondQuestion"
                :key="option.question"
                :value="option.question"
              >
                {{ option.label }}
              </option>
            </Select>
          </OnboardingField>
          <ValidationProvider
            rules="required"
            :name="$t('settings__security_questions_answer') + ' #2'"
          >
            <OnboardingInput
              v-model="securityQuestions[1].response"
              class="tw-mb-6"
              data-testid="security_questions_answer-2"
            />
          </ValidationProvider>
        </div>
      </div>

      <template #bottom>
        <div>
          <div class="tw-flex tw-justify-center tw-my-4">
            <Button @click="updateSecurity">{{ $t('onboarding_save') }}</Button>
          </div>
          <BottomActions
            v-if="showBackButton"
            @left-action-click="$emit('prev')"
            @right-action-click="$emit('next')"
          />
          <BottomActions v-else @right-action-click="$emit('next')" />
        </div>
      </template>
    </OnboardingModalContent>
  </ValidationObserver>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import OnboardingModalContent from './OnboardingModalContent'
import OnboardingField from '@/components/onboarding/OnboardingField'
import BottomActions from '@/components/onboarding/BottomActions'
import Select from '@/components/onboarding/Select'
import OnboardingInput from '@/components/onboarding/OnboardingInput'
import Button from '@/components/onboarding/Button'
import SecurityQuesionsMixin from '@/components/shared/SecurityQuestionsMixin'
import ValidationMixin from '@/components/onboarding/ValidationMixin'
import OnboardingMixin from '@/components/onboarding/OnboardingMixin'

export default {
  components: {
    OnboardingField,
    OnboardingModalContent,
    BottomActions,
    Select,
    OnboardingInput,
    Button,
    ValidationObserver,
    ValidationProvider,
  },
  mixins: [SecurityQuesionsMixin, ValidationMixin, OnboardingMixin],
  data() {
    return {
      securityQuestions: [
        {
          question: '',
          response: '',
        },
        {
          question: '',
          response: '',
        },
      ],
      formError: '',
    }
  },
  computed: {
    ...mapState('onboarding', ['securityQuestionsStored']),
    securityOptions() {
      return [
        {
          question: 'onboarding_sec_ques_born_city',
          label: this.$t('onboarding_security_question_text_1'),
        },
        {
          question: 'onboarding_sec_ques_first_street',
          label: this.$t('onboarding_security_question_text_2'),
        },
        {
          question: 'onboarding_sec_ques_oldest_cousin',
          label: this.$t('onboarding_security_question_text_3'),
        },
        {
          question: 'onboarding_sec_ques_partner_meet',
          label: this.$t('onboarding_security_question_text_4'),
        },
        {
          question: 'onboarding_sec_ques_first_pet',
          label: this.$t('onboarding_security_question_text_5'),
        },
        {
          question: 'onboarding_sec_ques_childhood_hero',
          label: this.$t('onboarding_security_question_text_6'),
        },
        {
          question: 'onboarding_sec_ques_fav_movie',
          label: this.$t('onboarding_security_question_text_7'),
        },
        {
          question: 'onboarding_sec_ques_city_mom',
          label: this.$t('onboarding_security_question_text_8'),
        },
        {
          question: 'onboarding_sec_ques_heirloom',
          label: this.$t('onboarding_security_question_text_9'),
        },
        {
          question: 'onboarding_sec_ques_city_dad',
          label: this.$t('onboarding_security_question_text_10'),
        },
      ]
    },
    securityQuestionsOptions() {
      return this.$store.state.dashboard.onboarding.securityQuestionsOptions
    },
  },
  mounted() {
    this.securityQuestions =
      this.securityQuestionsStored || this.securityQuestions
  },
  methods: {
    async updateSecurity() {
      const formValid = await this.validateForm()
      if (!formValid) {
        return
      }

      this.$emit('saving')
      this.$store.commit(
        'onboarding/setSecurityQuestions',
        this.securityQuestions
      )
      this.$axios
        .patch('/AUTH_URL/user', {
          security_questions: this.securityQuestions,
        })
        .then((r) => {
          this.$emit('next')
        })
    },
    getSecurityQuestions() {
      return this.securityOptions
    },
  },
}
</script>

<style></style>
